<app-dialog-heading [heading]="'NTU Application'"></app-dialog-heading>

<div class="dialog-container">
  <mat-dialog-content>
    <form [formGroup]="form">
      <div>
        <app-element-select
          [defaultValue]="selectedNtuReason"
          [options]="ntuReasons"
          [displayLabel]="'Select NTU Reason'"
          [required]="true"
          [emitNameValueDTO]="true"
          (selectionChanged)="onNtuReasonSelected($event)">
        </app-element-select>
      </div>

      <div>
        <app-element-multi-select
          [cssClasses]="['w-100']"
          [selectedValues]="selectedMissingInformationList"
          [options]="missingInformation"
          [displayLabel]="'Select Missing Information'"
          (selectedValuesChange)="onMissingInformationSelectionChanged($event)">
        </app-element-multi-select>
      </div>
    </form>

  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt2 flex">
    <button mat-raised-button color="primary" (click)="onClickSubmit()" [disabled]="!form.valid">
      Save
    </button>
    <button mat-raised-button color="warn" (click)="onClickCancel()">Cancel</button>
  </mat-dialog-actions>
</div>
